import { useState } from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import { Menu, X } from 'lucide-react';

interface MobileNavProps<T extends string> {
  items: { key: T; label: string; icon: React.ReactNode }[];
  activePage: T;
  onNavigate: (key: T) => void;
}

export function MobileNav<T extends string>({ items, activePage, onNavigate }: MobileNavProps<T>) {
  const [open, setOpen] = useState(false);

  return (
    <Dialog.Root open={open} onOpenChange={setOpen}>
      <Dialog.Trigger asChild>
        <button className="md:hidden p-2 text-foreground hover:bg-secondary rounded-md">
          <Menu className="h-6 w-6" />
        </button>
      </Dialog.Trigger>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-black/40 z-50 md:hidden" />
        <Dialog.Content className="fixed inset-y-0 left-0 w-64 bg-background border-r border-border z-50 p-4 md:hidden shadow-xl">
          <Dialog.Title className="sr-only">导航菜单</Dialog.Title>
          <Dialog.Description className="sr-only">选择页面进行跳转</Dialog.Description>
          <div className="flex items-center justify-between mb-6">
            <span className="text-lg font-medium">Quant</span>
            <Dialog.Close asChild>
              <button className="p-1 text-muted-foreground hover:text-foreground">
                <X className="h-6 w-6" />
              </button>
            </Dialog.Close>
          </div>
          <nav className="space-y-1">
            {items.map(({ key, label, icon }) => (
              <button
                key={key}
                onClick={() => {
                  onNavigate(key);
                  setOpen(false);
                }}
                className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-md text-sm transition ${
                  activePage === key
                    ? 'bg-[#533afd] text-white'
                    : 'text-foreground hover:bg-secondary'
                }`}
              >
                {icon}
                {label}
              </button>
            ))}
          </nav>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
